import styled from "styled-components"

export const ModalWrapper = styled.div`
    .mda {
        &_overlay {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            background-color: rgba(1, 1, 1, 35%);
            display: block;
            z-index: 10;
        }
        &_container {
            position: fixed;
            top: 72px;
            width: 900px;
            left: 30%;
            min-height: 200px;
            background-color: #fff;
            z-index: 20;
            border-radius: 4px;
            transition: all 0.3s linear;
        }
        &_header {
            color: #1c1c1c;
            text-align: center;
            border-bottom: 1px solid #ececec;
        }
        &_body {
            &_list {
                list-style: none;
                margin: 0;
                padding: 0;
            }
            &_item {
                margin-bottom: 22px;
                &_group_label {
                    display: block;
                    color: #1c1c1c;
                    font-weight: 500;
                    margin-bottom: 8px;
                }
                &_group_error {
                    margin: 0;
                    padding: 0;
                    color: #fb6e2e;
                    font-style: italic;
                }
                &_group_input {
                    padding: 0 12px;
                    height: 35px;
                    width: 100%;
                    border: 1px solid #e2c1c1;
                    outline: none;
                    color: #1c1c1c;
                    border-radius: 4px;
                    &:focus {
                        box-shadow: 1px 1px 1px rgba(1, 1, 1, 35%);
                    }
                }
                &_group_label-radio {
                    margin: 0 12px 0 4px;
                    cursor: pointer;
                }
            }
            &_control {
                display: flex;
                justify-content: flex-end;
                margin: 22px 0 0 0;
                border-top: 1px solid #e2c1c1;
                padding: 12px 0 0 0;
                button {
                    min-width: 120px;
                    margin-left: 12px;
                    height: 35px;
                   
                }
            }
        }
    }

`
